import React from 'react';
import Form from 'react-bootstrap/Form';
import * as yup from 'yup';

import _ from 'lodash';
import InputWidget from './InputWidget';

class TextInputWidget extends InputWidget {
    render() {
        return (
            <Form.Group>
                <Form.Label>{this.renderLabelText()}</Form.Label>
                <Form.Control
                    type="text"
                    name={this.getFieldName()}
                    value={this.getValue()}
                    isInvalid={this.isInvalid()}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    disabled={this.props.disabled}
                />
                <Form.Control.Feedback type="invalid">
                    {this.getError()}
                </Form.Control.Feedback>
                {this.getCustomRequiredError()}
            </Form.Group>
        );
    }
}

export function type() {
    return 'text_input';
}

export function initialValue(widget) {
    return '';
}

export function schema(widget, allowPartialSubmissions) {
    let schema = yup.string().nullable();

    if (widget.baseWidget || (!allowPartialSubmissions && widget.required)) {
        schema = schema.required();
    }

    if (_.isNumber(widget.maxLength)) {
        schema = schema.max(widget.maxLength);
    }

    return schema;
}

export function component() {
    return TextInputWidget;
}
